import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'

export default function Callback() {
    const auth = useAuth()

    useEffect(() => {
        // The react-oidc-context library handles the callback automatically
        // We just need to show a loading state while it processes
    }, [])

    if (auth.error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-red-600 mb-2">Authentication Error</h1>
                    <p className="text-gray-600 mb-4">{auth.error.message}</p>
                    <a
                        href="/login"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
                    >
                        Try Again
                    </a>
                </div>
            </div>
        )
    }

    if (auth.isAuthenticated) {
        return <Navigate to="/" replace />
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Signing you in...</h1>
                <p className="text-gray-600">Please wait while we complete your authentication.</p>
            </div>
        </div>
    )
}